import GoodsReturn from '@/service/goodsreturn'
import RequestUtils from './requestUtils.js'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getgoodsreturns(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(GoodsReturn.getgoodsreturns(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getgoodsreturn(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(GoodsReturn.getgoodsreturn(payload), {
        type: 'info',
        success,
        fail
      })
    },
    addgoodsreturnbynotag(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(GoodsReturn.addgoodsreturnbynotag(payload), {
        type: 'action',
        success,
        fail
      })
    },
    submitgoodsreturn(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(GoodsReturn.submitgoodsreturn(payload), {
        type: 'action',
        success,
        fail
      })
    },
    downloadreturntags(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(GoodsReturn.downloadreturntags(payload), {
        type: 'file',
        success,
        fail
      })
    },
    addpostsaleorder(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(GoodsReturn.addpostsaleorder(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getpostsaleorders(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(GoodsReturn.getpostsaleorders(payload), {
        type: 'list',
        success,
        fail
      })
    },
    closepostsaleorder(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(GoodsReturn.closepostsaleorder(payload), {
        type: 'action',
        success,
        fail
      })
    }
  }
}
